export default __webpack_public_path__ + "angle-right.364808ff53ed66fd2b6da4b3f609bf5d.svg";